// extracted by mini-css-extract-plugin
export default {"label":"NoDetailsFound_label__wKPMs","icon":"NoDetailsFound_icon__EIfcN","iconFront":"NoDetailsFound_iconFront__1nTUy","iconBack":"NoDetailsFound_iconBack__CDdcA"};